import type { ReactNode } from 'react';

import { type IconProps, Icon } from '../icon';

type GeneratedIconProps = Omit<IconProps, 'children' | 'name' | 'viewBox'> & {
    children?: never;
};

interface GenerateIconParameters {
    name?: string;
    path: ReactNode;
    props?: GeneratedIconProps;
    viewBox?: IconProps['viewBox'];
}

export const generateIconComponent = ({
    name,
    path,
    props: defaultProps,
    viewBox,
}: GenerateIconParameters) => {
    const Component = (props: IconProps) => {
        return (
            <Icon
                viewBox={viewBox}
                {...defaultProps}
                {...props}
                aria-hidden="true"
            >
                {path}
            </Icon>
        );
    };

    if (name) {
        Component.displayName = name;
    }

    return Component;
};
